import React, { createContext, useCallback, useContext, useState } from "react";
import { TE } from "./te";

const LangContext = createContext({ lang: "en", setLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem("wz_lang") || "en"; } catch { return "en"; }
  });
  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem("wz_lang", l); } catch { /* ignore */ }
  }, []);
  return <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);

export const useT = () => {
  const { lang } = useLang();
  return useCallback((s) => (lang === "te" && s ? TE[s] || s : s), [lang]);
};
